// extracted by mini-css-extract-plugin
export default {"wrapper":"eba-z","message":"fba-z","image":"gba-z"};